"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var G = require("@antv/g");
exports.G = G;
var Util = require("@antv/util");
exports.Util = Util;
var Interface = require("./interface");
exports.Interface = Interface;
var plot_1 = require("./plot/plot");
exports.Plot = plot_1.default;
var view_1 = require("./plot/view");
exports.View = view_1.default;
var element_1 = require("./element");
exports.Element = element_1.Element;
exports.getElement = element_1.getElement;
exports.registerElement = element_1.registerElement;
var area_1 = require("./element/area");
var box_1 = require("./element/box");
var edge_1 = require("./element/edge");
var heatmap_1 = require("./element/heatmap");
var interval_1 = require("./element/interval");
var k_line_1 = require("./element/k-line");
var line_1 = require("./element/line");
var path_1 = require("./element/path");
var point_1 = require("./element/point");
var polygon_1 = require("./element/polygon");
var Shape = require("./element/shape/base");
exports.Shape = Shape;
var text_1 = require("./element/text");
// 注册 element
element_1.registerElement('Line', line_1.default);
element_1.registerElement('Path', path_1.default);
element_1.registerElement('Point', point_1.default);
element_1.registerElement('Interval', interval_1.default);
element_1.registerElement('Edge', edge_1.default);
element_1.registerElement('Polygon', polygon_1.default);
element_1.registerElement('Area', area_1.default);
element_1.registerElement('Box', box_1.default);
element_1.registerElement('Kline', k_line_1.default);
element_1.registerElement('Text', text_1.default);
element_1.registerElement('Heatmap', heatmap_1.default);
var base_1 = require("./element/shape/base");
exports.registerShape = base_1.registerShape;
exports.registerShapeFactory = base_1.registerShapeFactory;
exports.getShapeFactory = base_1.getShapeFactory;
var facet_1 = require("./facet");
exports.Facet = facet_1.Facet;
exports.registerFacet = facet_1.registerFacet;
var rect_1 = require("./facet/rect");
facet_1.registerFacet('rect', rect_1.Rect);
var interaction_1 = require("./interaction");
exports.registerInteraction = interaction_1.registerInteraction;
exports.getInteraction = interaction_1.getInteraction;
exports.Interaction = interaction_1.Interaction;
var global_1 = require("./global");
exports.Global = global_1.default;
exports.setTheme = global_1.setTheme;
exports.version = global_1.version;
var theme_1 = require("./theme");
exports.registerTheme = theme_1.registerTheme;
exports.getTheme = theme_1.getTheme;
var animate_1 = require("./animate/animate");
exports.Animate = animate_1.default;
var scale_1 = require("@antv/scale");
exports.registerScale = scale_1.registerScale;
exports.getScale = scale_1.getScale;
exports.Scale = scale_1.Scale;
var adjust_1 = require("@antv/adjust");
exports.registerAdjust = adjust_1.registerAdjust;
exports.getAdjust = adjust_1.getAdjust;
exports.Adjust = adjust_1.Adjust;
var coord_1 = require("@antv/coord");
exports.getCoordinate = coord_1.getCoordinate;
exports.Coordinate = coord_1.Coordinate;
var attr_1 = require("@antv/attr");
exports.getAttribute = attr_1.getAttribute;
exports.Attribute = attr_1.Attribute;
var Option = require("./plot/interface");
exports.Option = Option;
var label_1 = require("./element/controller/label/");
exports.registerElementLabels = label_1.registerElementLabels;
exports.getElementLabels = label_1.getElementLabels;
exports.ElementLabels = label_1.ElementLabels;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/index.js
// module id = 23
// module chunks = 37